export const LOAD_OPTIONS_SUCCESS = "LOAD_OPTIONS_SUCCESS";
export const BEGIN_API_CALL = "BEGIN_API_CALL";
export const API_CALL_ERROR = "API_CALL_ERROR";
export const LOAD_RECIPES_SUCCESS = "LOAD_RECIPES_SUCCESS";
export const CREATE_RECIPE_SUCCESS = "CREATE_RECIPE_SUCCESS";
export const UPDATE_RECIPE_SUCCESS = "UPDATE_RECIPE_SUCCESS";
export const VERIFY_USER = "VERIFY_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const DELETE_RECIPE_OPTIMISTIC = "DELETE_RECIPE_OPTIMISTIC";
export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const LOAD_PROFILE = "LOAD_PROFILE";
export const ADD_RECIPE_TO_FAVORITES_OPTIMISTIC =
  "ADD_RECIPE_TO_FAVORITES_OPTIMISTIC";
export const REMOVE_RECIPE_FROM_FAVORITES_OPTIMISTIC =
  "REMOVE_RECIPE_FROM_FAVORITES_OPTIMISTIC";
export const FIREBASE_AUTH_STATUS = "FIREBASE_AUTH_STATUS";
export const ADD_USER_ID = "ADD_USER_ID";
export const DELETE_RECIPE_INGREDIENT_OPTIMISTIC =
  "DELETE_RECIPE_INGREDIENT_OPTIMISTIC";
export const DELETE_RECIPE_STEP_OPTIMISTIC = "DELETE_RECIPE_STEP_OPTIMISTIC";
export const CLEAR_USER = "CLEAR_USER";
export const LOAD_USER_RECIPES_SUCCESS = "LOAD_USER_RECIPES_SUCCESS";
export const LOAD_REGAN_RAE_FAVORITES = "LOAD_REGAN_RAE_FAVORITES";
export const VERIFY_NOTHING = "VERIFY_NOTHING"; //* USED FOR TESTING
export const UPDATE_RECIPE_ADMIN_OPTIMISTIC = "UPDATE_RECIPE_ADMIN_OPTIMISTIC";
